import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const QuickAddWrapper = componentWithFF(
	'issue-view-fit-and-finish-full-page-milestone2_ebk0i',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
	styled.div({
		marginBottom: token('space.050', '4px'),
		marginTop: token('space.050', '4px'),
		padding: `${token('space.050', '4px')} 0`,
		display: 'inline-flex',
	}),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
	styled.div({
		marginBottom: token('space.050', '4px'),
		padding: `${token('space.050', '4px')} 0`,
		display: 'inline-flex',
	}),
);
